const restrictionIps = ["70.28.88.193", "24.53.29.219"];

const isIpRestricted = () => getIp().then((ip) => ip != null && restrictionIps.includes(ip));

document.addEventListener("DOMContentLoaded", function () {
  isIpRestricted().then((isRestricted) => {
    let restrictedElements = Array.from(
      document.getElementsByClassName("ip-restricted")
    );
    if (!isRestricted)
      restrictedElements.forEach((restrictedEl) => restrictedEl.remove());
    else
      restrictedElements.forEach((restrictedEl) =>
        restrictedEl.classList.add("show-restricted")
      );
  });
});
